/**
 * @file Service for uploading photos to the photo moderation service.
 */
import { PhotoUploadPayload } from "../../types";

export default async function photoModerationUpload(
  base64Photo: string
): Promise<PhotoUploadPayload> {
  // Move config extraction inside function so it runs at execution time, not import time
  const { baseURL, apiKey } = window?.wvusSakEngagementAppSettings?.photoModConfig ?? {};

  // Check for required configuration
  if (!baseURL || !apiKey) {
    throw new Error(
      "Photo moderation configuration is missing. Please ensure baseURL and apiKey are provided."
    );
  }

  const photoModUrl = `${baseURL}/photomoderation/upload?contentType=image/jpeg`;

  // Call photo moderation service
  const response = await fetch(photoModUrl, {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      "Ocp-Apim-Subscription-Key": apiKey
    },
    body: base64Photo
  });

  const data = await response.json();

  return data as PhotoUploadPayload;
}
